import React, { useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import api from '../../api/axios';
import {
    Legend, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer,
    Area, AreaChart, Pie, PieChart, Cell
} from 'recharts';

import * as conv from '../utils/converter'

const Dashboard = () => {
    // const location = useLocation();
    const [selectedCID, setSelectedCID] = useState('');
    // const colors = [
    //     '#A3C9A8', // soft green
    //     '#FFD6A5', // pastel orange
    //     '#B5EAD7', // mint
    //     '#FFDAC1', // peach
    //     '#C7CEEA', // lavender
    //     '#E2F0CB', // light lime
    //     '#FFB7B2', // rose
    //     '#D5AAFF'  // soft purple
    // ];

    const colors = [
        '#4E79A7', // bold soft blue
        '#F28E2B', // bold pastel orange
        '#E15759', // soft crimson red
        '#76B7B2', // soft teal
        '#59A14F', // modern green
        '#EDC948', // golden yellow
        '#B07AA1', // muted purple
        '#FF9DA7'  // soft coral pink
    ];

    const [user, setUser] = useState({ UserID: '', DisplayName: '' });
    const [stats, setStats] = useState({
        totalSales: 125000,
        currentBalance: 82000,
        outstandingLoans: 30500,
    });
    const [recentActivity, setRecentActivity] = useState([
        { date: '2025-04-18', activity: 'Loan disbursed to member A', amount: 5000 },
        { date: '2025-04-19', activity: 'Loan repayment from member B', amount: 1500 },
        { date: '2025-04-20', activity: 'Savings deposit by member C', amount: 2000 },
    ]);
    const [salesData, setSalesData] = useState([
        { name: 'Mon', value: 3000 },
        { name: 'Tue', value: 4500 },
        { name: 'Wed', value: 4700 },
        { name: 'Thu', value: 3200 },
        { name: 'Fri', value: 5100 },
    ]);
    const [areaContrib, setAreaContrib] = useState([
        {
            "Region": "BANJARNEGARA",
            "TotalJual": 1224698171
        },
        {
            "Region": "KEBUMEN",
            "TotalJual": 6970175949
        },
        {
            "Region": "PURBALINGGA",
            "TotalJual": 3755291381
        },
        {
            "Region": "PURWOREJO",
            "TotalJual": 1774419110
        }
    ]);
    const [cidDailySales, setCIDDailySales] = useState([]);
    const regionNames = React.useMemo(() => {
        const regions = new Set();
        cidDailySales.forEach(item => {
            Object.keys(item).forEach(key => {
                if (key !== 'day') {
                    regions.add(key);
                }
            });
        });
        return Array.from(regions);
    }, [cidDailySales]);


    const productGroups = React.useMemo(() => {
        const productGroup = new Set();
        salesData.forEach(item => {
            Object.keys(item).forEach(key => {
                if (key !== 'DayName') {
                    productGroup.add(key);
                }
            });
        });
        return Array.from(productGroup);
    }, [salesData]);

    useEffect(() => {
        const storedCID = localStorage.getItem("cid");
        if (storedCID) {
            setSelectedCID(storedCID);
        }
    }, []);
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUser({ UserID: decoded.UserID, DisplayName: decoded.DisplayName });
            } catch (err) {
                console.error('Invalid token');
            }
        }


        const fetchMDA = async () => {
            if (!selectedCID) return;
            try {
                // const token = Cookies.get('token');
                const token = localStorage.getItem('token')
                const res = await api.post('dashboard/achievementMDA', { cid: selectedCID }, {
                    headers: { authorization: token },
                });
                console.log('MDA:', res.data.data)
                setStats(res.data.data);
            } catch (error) {
                console.error('Error fetching inventory:', error);
            }
        };
        fetchMDA();


        const fetchAreaContribution = async () => {
            if (!selectedCID) return;
            try {
                // const token = Cookies.get('token');
                const token = localStorage.getItem('token')
                const res = await api.post('dashboard/areacontribution', { cid: selectedCID }, {
                    headers: { authorization: token },
                });
                console.log('Area Contribution:', res.data.data)
                setAreaContrib(res.data.data);
            } catch (error) {
                console.error('Error fetching inventory:', error);
            }
        };
        fetchAreaContribution();

        const fetchSalesDailyPerRegion = async () => {
            if (!selectedCID) return;
            try {
                // const token = Cookies.get('token');
                const token = localStorage.getItem('token')
                const res = await api.post('dashboard/dailysalesperreg', { cid: selectedCID }, {
                    headers: { authorization: token },
                });
                // console.log('DailySales Data:', res.data.data)
                setCIDDailySales(res.data.data);
            } catch (error) {
                console.error('Error fetching inventory:', error);
            }
        };
        fetchSalesDailyPerRegion();

        const fetchSalesDailyPerProductGroup = async () => {
            if (!selectedCID) return;
            try {
                // const token = Cookies.get('token');
                const token = localStorage.getItem('token')
                const res = await api.post('dashboard/dailysalesperproductgroup', { cid: selectedCID }, {
                    headers: { authorization: token },
                });
                console.log('DailySales Per Groups:', res.data.data)
                setSalesData(res.data.data);
            } catch (error) {
                console.error('Error fetching inventory:', error);
            }
        };
        fetchSalesDailyPerProductGroup();

        const fetchRecentActivity = async () => {
            if (!selectedCID) return;
            try {
                // const token = Cookies.get('token');
                const token = localStorage.getItem('token')
                const res = await api.post('dashboard/recentactivity', { cid: selectedCID }, {
                    headers: { authorization: token },
                });
                console.log('Recent Acitivy:', res.data.data)
                setRecentActivity(res.data.data);
            } catch (error) {
                console.error('Error fetching inventory:', error);
            }
        };
        fetchRecentActivity();

    }, [selectedCID]);

    return (
        <div className="container-fluid px-4 py-3 page-wrapper">
            <div className="mb-4">
                <h3 className="fw-bold mb-1">Selamat datang, {user.DisplayName || 'User'}!</h3>
                <p className="text-body-secondary">
                    Halaman ini menampilkan data terkini yang telah terintegrasi secara real-time.
                    Silakan gunakan fitur yang tersedia sesuai kebutuhan Anda. Update: {conv.formatDate(stats.UpdateDate)}
                </p>
            </div>

            <div className="row g-4 mb-4">
                {[
                    { label: 'Total Sales', value: (conv.formatnumber(stats.TotalJual)), className: 'text-primary' },
                    { label: 'Current Balance', value: (conv.formatnumber(stats.TotalHPP)), className: 'text-success' },
                    { label: 'Outstanding Loans', value: 'Not Available', className: 'text-danger' }// (conv.formatnumber(stats.SisaPiutang)), className: 'text-danger' },
                ].map((item, i) => (
                    <div className="col-md-4" key={i}>
                        <div className="card shadow-sm rounded-4 border-0 bg-light">
                            <div className="card-body p-4">
                                <p className="text-body-secondary mb-1">{item.label}</p>
                                <h4 className={`fw-semibold ${item.className}`}> {item.value}</h4>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body p-4">
                    <h5 className="card-title mb-4">Daily Sales by Area</h5>
                    <ResponsiveContainer width="100%" height={320}>
                        <AreaChart data={cidDailySales} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
                            <defs>
                                {regionNames.map((region, index) => (
                                    <linearGradient key={region} id={`color-${region}`} x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor={colors[index % colors.length]} stopOpacity={0.6} />
                                        <stop offset="95%" stopColor={colors[index % colors.length]} stopOpacity={0.05} />
                                    </linearGradient>
                                ))}
                            </defs>

                            <CartesianGrid strokeDasharray="3 4" stroke="#f0f0f0" />
                            <XAxis dataKey="day" stroke="#999" />
                            <YAxis stroke="#999" tickFormatter={(value) => `${(value / 1000000).toFixed(0)}M`} />
                            <Tooltip
                                formatter={(value) => `${value.toLocaleString()}`}
                                contentStyle={{ borderRadius: '10px', backgroundColor: '#fff', borderColor: '#ccc' }}
                            />
                            <Legend />

                            {regionNames.map((region, index) => (
                                <Area
                                    key={region}
                                    type="monotone"
                                    dataKey={region}
                                    stroke={colors[index % colors.length]}
                                    fillOpacity={1}
                                    fill={`url(#color-${region})`}
                                    strokeWidth={2}
                                    dot={{ r: 3 }}
                                    activeDot={{ r: 5 }}
                                    connectNulls
                                />
                            ))}
                        </AreaChart>
                    </ResponsiveContainer>

                </div>
            </div>

            <div className="row g-4 mb-4">
                <div className="col-md-6">
                    <div className="card shadow-sm rounded-4 border-0">
                        <div className="card-body p-4">
                            <h6 className="mb-3 fw-semibold">Sales Activity This Week</h6>
                            <ResponsiveContainer width="100%" height={320}>
                                <AreaChart data={salesData} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
                                    <CartesianGrid strokeDasharray="3 4" />
                                    <XAxis dataKey="DayName" />
                                    <YAxis tickFormatter={(value) => `${(value / 1000000).toFixed(0)}M`} />
                                    <Tooltip formatter={(value) => `${value.toLocaleString()}`} />
                                    <Legend />
                                    {productGroups.map((productGroup, index) => (
                                        <Area
                                            key={productGroup}
                                            type="monotone"
                                            dataKey={productGroup}
                                            stroke={colors[index % colors.length]}
                                            fill={colors[index % colors.length]}
                                            strokeWidth={2}
                                            dot={{ r: 3 }}
                                            activeDot={{ r: 5 }}
                                            connectNulls
                                        />
                                    ))}
                                </AreaChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card shadow-sm rounded-4 border-0">
                        <div className="card-body p-4">
                            <h6 className="mb-3 fw-semibold">Area Contribution</h6>
                            <ResponsiveContainer width="100%" height={320}>
                                <PieChart>
                                    <Pie
                                        data={areaContrib}
                                        dataKey="TotalJual"
                                        nameKey="Region"
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={110}
                                        innerRadius={60} // This makes it a donut chart, looks more modern
                                        fill="#8884d8"
                                        paddingAngle={3}
                                        label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                    >
                                        {areaContrib.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                                        ))}
                                    </Pie>
                                    <Tooltip
                                        formatter={(value) => `${Number(value).toLocaleString()}`}
                                        contentStyle={{ borderRadius: '10px', backgroundColor: '#fff', borderColor: '#ccc' }}
                                    />
                                    <Legend verticalAlign="bottom" height={36} />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row g-4 mb-4">
                <div className="col-md-12">
                    <div className="card shadow-sm rounded-4 border-0">
                        <div className="card-body p-4">
                            <h6 className="mb-3 fw-semibold">Recent Activity</h6>
                            <ul className="list-group list-group-flush">
                                {recentActivity.map((item, idx) => (
                                    <li className="list-group-item px-0 d-flex justify-content-between" key={idx}>
                                        <div>
                                            <div className="fw-medium">{item.ActivityNote}</div>
                                            <small className="text-muted">{conv.getTimeOnly(item.Epoch)}</small>
                                        </div>
                                        <span className="fw-bold">{conv.formatnumber(item.Amount)}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="row mb-4">
                <div className="col">
                    <div className="card bg-light shadow-sm rounded-4 border-0 p-3">
                        <div className="card-body d-flex flex-wrap gap-3 justify-content-center">
                            <button className="btn btn-outline-primary rounded-pill d-flex align-items-center gap-2">
                                <i className="fas fa-user-plus"></i> New Member
                            </button>
                            <button className="btn btn-outline-secondary rounded-pill d-flex align-items-center gap-2">
                                <i className="fas fa-piggy-bank"></i> Deposit Savings
                            </button>
                            <button className="btn btn-outline-success rounded-pill d-flex align-items-center gap-2">
                                <i className="fas fa-hand-holding-usd"></i> Loan Request
                            </button>
                            <button className="btn btn-outline-warning rounded-pill d-flex align-items-center gap-2">
                                <i className="fas fa-chart-line"></i> View Reports
                            </button>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default Dashboard;
